{
  "Kullanıcılar": "Users",
  "kullanicilar": {
    "Admin Olanlar": "Admin Users",
    "Admin Olmayanlar": "Non-Admin Users",
    "Bilgisayardan Yükle": "Upload from Computer",
    "Evet, değiştir": "Yes, change it.",
    "Fotoğrafı Düzenle": "Edit Photo",
    "Group Yetki": "Group Permission",
    "Güvenlik": "Security",
    "Henüz fotoğraf seçilmedi veya çekilmedi": "No photo selected or taken yet.",
    "Kullanıcı Profil": "User Profile",
    "Kullanıcılar": "Users",
    "Resmi sürükleyerek konumlandırabilirsiniz": "You can drag the image to reposition.",
    "Sağa Döndür": "Rotate Right",
    "Sola Döndür": "Rotate Left",
    "Yeni Group Yetki": "New Group Permission",
    "Yetki": "Permission",
    "Yetkileri": "Permissions",
    "veya Webcam Kullan": "or Use Webcam",
    "Çek": "Take Photo",
    "Önizleme": "Preview",
    "İsim": "Name",
    "Şifre Değişikliği Yapılıyor?": "Changing Password?",
    "Ara": "Search",
    "Temizle": "Clear",
    "Kapat": "Close",
    "Durum": "Status",
    "Yenile": "Refresh",
    "E-mail": "Email",
    "Admin": "Admin",
    "Yeni Kullanıcı": "New User",
    "Kayıt": "Register",
    "Güncelle": "Update",
    "Sil": "Delete",
    "Şifreyi Güncelle": "Update Password",
    "Ad Soyad": "Full Name",
    "E-posta Şifresi Değiştir": "Change Email Password",
    "Yeni E-posta Şifresi": "New Email Password",
    "Email": "Email",
    "Grafikler": "Charts",
    "Onaylı": "Approved",
    "Onaysız": "Unapproved",
    "Toplam": "Total",
    "Hedef": "Target",
    "Yapılan": "Completed",
    "Randevu": "Appointment",
    "Referans": "Reference",
    "Satış": "Sale",
    "Sira": "Order",
    "Kod": "Code",
    "Baslik": "Title",
    "UstKod": "Parent Code",
    "GrupBaslik": "Group Title",
    "YetkiListesi": "Authority List",
    "DataYenile": "Refresh",
    "Aktif": "Active",
    "Pasif": "Passive",
    "Aksiyonlar": "Actions",
    "YetkiDuzenle": "Edit Authority",
    "YetkiEkle": "Add Authority",
    "Iptal": "Cancel",
    "Kaydet": "Save",
    "SilmeOnayi": "Delete Confirmation",
    "YetkiSilmeMesaji": "Are you sure you want to delete authority {name}?",
    "Hayir": "No",
    "Evet": "Yes",
    "Aciklama": "Description",
    "Mesai": "Overtime"
  }
}
